
<div class="wrapper shadowed">
    <h4>Fiabilité mensuelle</h4>
    <mat-tab-group mat-align-tabs="center">
        <mat-tab label="Globale">
            <app-rates-view machine="total"></app-rates-view>
        </mat-tab>
        <mat-tab label="Pizzadoor">
            <app-rates-view machine="pizzadoor"></app-rates-view>
        </mat-tab>
        <mat-tab label="Panidoor">
            <app-rates-view machine="panidoor"></app-rates-view>
        </mat-tab>
    </mat-tab-group>
</div>